import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import CategoryCard from './CategoryCard';
import { FaLaptop, FaCouch, FaCar, FaHome } from 'react-icons/fa'; // Import icons
import './PopularCategories.css';

const categories = [
  { id: 1, title: 'Electronics', Icon: FaLaptop },
  { id: 2, title: 'Furniture', Icon: FaCouch },
  { id: 3, title: 'Vehicles', Icon: FaCar },
  { id: 4, title: 'Real Estate', Icon: FaLaptop },
  { id: 5, title: 'Fashion', Icon: FaHome },
  { id: 6, title: 'Sports', Icon: FaHome },
  { id: 7, title: 'Books', Icon: FaHome },
  { id: 8, title: 'Dildos', Icon: FaHome },
];

const PopularCategories = () => (
  <div className='popular-categories-bg'>
    <Container className='popular-categories-container'>
      <div className='popular-categories'>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2 className='pop-cat-heading'>Popular<br /> Categories</h2>
          <Link to="/categories">
            <Button className="btn btn-danger view-all-cat-btn">View All Categories</Button>
          </Link>
        </div>
        <Row className='d-flex align-items-stretch'>
          {categories.map(category => (
            <Col key={category.id} xs={6} sm={6} md={4} lg={3} className="mb-4">
              <CategoryCard
                id={category.id}
                title={category.title}
                Icon={category.Icon}
              />
            </Col>
          ))}
        </Row>
      </div>
    </Container>
  </div>
);

export default PopularCategories;